export type villaReserveCancellationPolicyType = {
  policies: Array<VillaCancellationRulesType>;
  cancellationPlanType: CancellationPlanType;
};

export enum CancellationRulesImportance {
  NORMAL = "NORMAL",
  PEAK_TIME = "PEAK_TIME",
  NEW_YEAR = "NEW_YEAR"
}

export enum CancellationPlanType {
  EASY = "EASY",
  MEDIUM = "MEDIUM",
  HARD = "HARD",
  UNKNOWN = "UNKNOWN"
}

export type VillaCancellationRulesType = {
  title: string;
  text: string;
  type: CancellationRulesImportance;
};
export const cancellationPlan = {
  [CancellationPlanType.EASY]: "سهل گیرانه",
  [CancellationPlanType.MEDIUM]: "متعادل",
  [CancellationPlanType.HARD]: "سخت گیرانه",
  [CancellationPlanType.UNKNOWN]: ""
};
